import { createReduxAsyncAction } from '../utils/toolkit';
import { TYPES } from './constants';

export const loadVehicle = createReduxAsyncAction(TYPES.LOAD_VEHICLE);
export const createVehicle = createReduxAsyncAction(TYPES.CREATE_VEHICLE);
export const saveVehicle = createReduxAsyncAction(TYPES.SAVE_VEHICLE);
export const deleteVehicle = createReduxAsyncAction(TYPES.DELETE_VEHICLE);
